// Mock data for the marketing agency website

export const mockData = {
  // Contact form submissions
  contactSubmissions: [
    {
      id: '1',
      name: 'John Smith',
      contact: 'john@example.com',
      niche: 'E-commerce',
      objective: 'Increase sales by 50%',
      timestamp: '2024-01-15T10:30:00Z',
      status: 'new'
    },
    {
      id: '2',
      name: 'Sarah Johnson',
      contact: '@sarahj_telegram',
      niche: 'SaaS',
      objective: 'Lead generation',
      timestamp: '2024-01-14T15:45:00Z',
      status: 'contacted'
    }
  ],

  // Services data
  services: {
    overview: [
      {
        id: 'social-advertising',
        title: 'Advertising and Promotion in Social Networks',
        subServices: [
          'Advertising in Telegram channels',
          'Advertising in Instagram (stories, posts, targeting)',
          'Advertising in WhatsApp and Viber mailings',
          'Promotion via Facebook and other social networks'
        ]
      },
      {
        id: 'media-planning',
        title: 'Media Planning and Strategy',
        subServices: [
          'Development of an individual advertising strategy',
          'Target audience analysis',
          'Drafting a media plan with channel selection and budgets',
          'Promotion consultations'
        ]
      },
      {
        id: 'content-marketing',
        title: 'Content Marketing',
        subServices: [
          'Development of a content plan for social networks',
          'Copywriting (advertising texts, posts, scripts for stories/videos)',
          'Visual design (banners, creatives, animations)',
          'Creating creatives for advertising'
        ]
      },
      {
        id: 'targeting',
        title: 'Targeting and Advertising',
        subServices: [
          'Setting up targeted advertising on Instagram/Facebook',
          'Optimization of advertising campaigns',
          'Retargeting (repeated advertising to those who have already shown interest)'
        ]
      },
      {
        id: 'influence-marketing',
        title: 'Influence Marketing',
        subServices: [
          'Selection of bloggers and opinion leaders',
          'Organization of advertising with bloggers',
          'Control of cooperation results'
        ]
      },
      {
        id: 'analytics',
        title: 'Analytics and Reporting',
        subServices: [
          'Analysis of advertising campaign effectiveness',
          'Weekly/monthly reports',
          'Optimization of budgets for results'
        ]
      },
      {
        id: 'additional',
        title: 'Additional Services',
        subServices: [
          'Creation and maintenance of Telegram channels'
        ]
      }
    ],

    detailed: [
      {
        id: 'telegram',
        title: 'Telegram Advertising',
        description: 'Forget about chaotic placements. We only find channels where your audience truly exists. We present your product with diligence and track results down to the last click.',
        highlight: 'Your brand is seen by those who are ready to buy.',
        icon: 'MessageCircle'
      },
      {
        id: 'instagram',
        title: 'Instagram Advertising',
        description: 'A beautiful picture is good, but we make it sell. We set up targeted campaigns, craft creatives, test hypotheses, and build a loyal audience around your product/service.',
        highlight: 'Advertising that does not annoy, but captivates.',
        icon: 'Instagram'
      },
      {
        id: 'whatsapp',
        title: 'WhatsApp/Viber Advertising',
        description: 'Not a mass mailing, but a personal appeal. We create message scripts that get read and responded to.',
        highlight: 'You get a live dialogue with customers, not just message delivery.',
        icon: 'MessageSquare'
      },
      {
        id: 'influence',
        title: 'Influence Marketing',
        description: 'We don\'t spill the budget on random bloggers. We hand-pick influencers who truly impact your audience, manage the collaboration, and provide a clear report of the sales and leads obtained.',
        highlight: 'Your brand is recommended by those whom your audience trusts.',
        icon: 'Users'
      },
      {
        id: 'media-planning',
        title: 'Media Planning & Analytics',
        description: 'No disordered actions. We develop a clear plan of where to advertise, required budgets, and expected results. Then we switch to an adaptive model: monitoring and optimizing every week.',
        highlight: 'You always know how your money is working.',
        icon: 'BarChart3'
      },
      {
        id: 'content',
        title: 'Content Management (Instagram/Telegram)',
        description: 'Advertising without quality content is a waste of money. We handle the full cycle: creating a content plan, writing copy, designing visuals, and managing your social accounts so that they sell, not just collect likes.',
        highlight: 'Your social networks become platforms that truly generate customers.',
        icon: 'Edit3'
      },
      {
        id: 'strategy',
        title: 'Strategy & Consulting',
        description: 'Individual consultations and development of a comprehensive digital strategy. We help identify where your advertising will achieve the best results.',
        highlight: 'Tailored strategies for maximum ROI.',
        icon: 'Target'
      },
      {
        id: 'creatives',
        title: 'Creatives & Design',
        description: 'Creation of advertising banners, stories, videos, and visuals that stand out from the competition and immediately attract attention.',
        highlight: 'Designs that convert browsers into buyers.',
        icon: 'Palette'
      }
    ]
  },

  // FAQ data
  faq: [
    {
      id: 'start',
      question: 'Where does the work start?',
      answer: 'We start with a short brief and a free media plan. Once you approve, we proceed and launch the campaign.'
    },
    {
      id: 'guarantees',
      question: 'What are the guarantees?',
      answer: 'We guarantee transparent analytics, continuous hypothesis testing, and constant optimization to meet your KPIs.'
    },
    {
      id: 'niche',
      question: 'Do you work with my niche?',
      answer: 'Yes. We research and select channels and create creatives specifically tailored to your industry/niche.'
    },
    {
      id: 'timeline',
      question: 'How long does it take to launch?',
      answer: 'We work very quickly – campaign launch usually occurs within 1-2 days after agreement.'
    },
    {
      id: 'budget',
      question: 'What budgets are needed?',
      answer: 'Budgets are determined by your goals – whether it\'s a small test campaign, a stable lead flow, or aggressive scaling, we will propose a suitable budget plan.'
    }
  ],

  // Why choose us data
  whyUs: {
    intro: 'We don\'t do \'just advertising\' – we create a strategy tailored to your business.',
    points: [
      {
        title: 'Transparent reporting',
        description: 'You see real numbers, not just beautiful slides.'
      },
      {
        title: 'Wide-range experience',
        description: 'We have worked with diverse niches from e-commerce to services.'
      },
      {
        title: 'Results-driven',
        description: 'We work for results, not for big budgets.'
      }
    ]
  },

  // Mock form submission handler
  submitContactForm: (formData) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const newSubmission = {
          id: Date.now().toString(),
          ...formData,
          timestamp: new Date().toISOString(),
          status: 'new'
        };
        
        // In a real app, this would go to the backend
        console.log('Form submitted:', newSubmission);
        
        resolve({
          success: true,
          message: 'Thank you! We\'ll contact you within 24 hours with a personalized strategy.',
          submissionId: newSubmission.id
        });
      }, 1000);
    });
  }
};

export default mockData;